var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container",
    staticStyle: {
      "font-size": "56px",
      color: "skyblue"
    }
  }, [_c("img", {
    attrs: {
      src: "https://tpage.soimt.com/APP/SNS/map1.jpg",
      alt: ""
    }
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };